import React, { useState } from "react";
import s from './Paginator.module.scss'

const Paginator = ({ getUsersThunk, currentPage, totalUsersCount, pageSize, portionSize }) => {

  let pagesCount = Math.ceil(totalUsersCount / pageSize)
  let pages = []
  for (let i = 1; i <= pagesCount; i++) pages.push(i)

  let portionCount = Math.ceil(pagesCount / portionSize)
  let [portionNumber, setPortionNumber] = useState(1)
  let leftPortionPageNumber = (portionNumber - 1) * portionSize + 1
  let rightPortionPageNumber = portionNumber * portionSize;

  return (
    <div className={s.paginator}>
      {portionNumber > 1 &&
        <button className={s.prevBtn} onClick={() => { setPortionNumber(portionNumber - 1); getUsersThunk(leftPortionPageNumber - 1, pageSize) }}>
          <i class="fa-solid fa-angles-left"></i>
        </button>
      }
      {
        pages
          .filter(p => p >= leftPortionPageNumber && p <= rightPortionPageNumber)
          .map(p => {
            return <span className={currentPage === p ? `${s.default}  ${s.active}` : s.default} key={p}
              onClick={() => {
                getUsersThunk(p, pageSize);
              }}
            >{p} </span>
          })
      }
      {
        portionCount > portionNumber &&
        <button className={s.nextBtn} onClick={() => { setPortionNumber(portionNumber + 1); getUsersThunk(rightPortionPageNumber + 1, pageSize) }}>
          <i class="fa-solid fa-angles-right"></i>
        </button>
      }
    </div>

  );
}

export default Paginator;